function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Alert, Spin, Button, Select, Space, Divider, Breadcrumb } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import { PersonVcardFill, TelephoneFill, KeyFill } from "react-bootstrap-icons";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var NewUserForm = function NewUserForm(_ref) {
  var handleUpdate = _ref.handleUpdate;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormPrecessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    compsOptions = _useState8[0],
    setCompsOptions = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    insOptions = _useState0[0],
    setInsOptions = _useState0[1];
  var _useState1 = useState(true),
    _useState10 = _slicedToArray(_useState1, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    companyId = _useState12[0],
    setCompanyId = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    insId = _useState14[0],
    setInsId = _useState14[1];
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    companyOptionDisabled = _useState16[0],
    setCompanyOptionDisabled = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    insOptionDisabled = _useState18[0],
    setInsOptionDisabled = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    depList = _useState20[0],
    setDepList = _useState20[1];
  var onRoleOptionChange = function onRoleOptionChange(v) {
    if (v == 12) {
      setCompanyOptionDisabled(false);
      setInsOptionDisabled(true);
    }
    if (v == 13) {
      setCompanyOptionDisabled(true);
      setInsOptionDisabled(false);
    }
  };
  var onCompanyOptionChange = function onCompanyOptionChange(v) {
    setCompanyId(v);
  };
  var onInsOptionChange = function onInsOptionChange(v) {
    setInsId(v);
  };
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage('');
    setSuccessMessage('');
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('mobile', values.mobile);
    formData.append("company_id", null);
    formData.append("insurance_id", insId);
    formData.append("department_id", values.department_id);
    formData.append('role', values.role);
    formData.append('password', values.password);
    axios.post(Common.baseApiUrl + 'createuser/' + Common.currentUser.id, formData).then(function (response) {
      setIsFormProcessing(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handleUpdate();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.all([axios.get(Common.baseApiUrl + 'getcompanylist/' + Common.currentUser.id), axios.get(Common.baseApiUrl + "geticompanylist/" + Common.currentUser.id), axios.get("".concat(Common.baseApiUrl, "getdepartments"))]).then(function (response) {
      if (response[0].data.status == 200) {
        response[0].data.companyList.forEach(function (element) {
          setCompsOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: element.label,
              value: element.id
            }]);
          });
        });
        form.setFieldsValue({
          company_id: compsOptions
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        response[1].data.iclist.forEach(function (element) {
          setInsOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: element.label,
              value: element.id
            }]);
          });
        });
        form.setFieldsValue({
          insurance_company_id: compsOptions
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
      if (response[2].data.status == 200) {
        response[2].data.departments.forEach(function (d) {
          setDepList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: d.id,
              label: d.label
            }]);
          });
        });
        if (response[2].data.departments.length > 0) form.setFieldsValue({
          department_id: response[2].data.departments[0].id
        });
      }
    })["catch"](function (error) {});
    form.setFieldsValue({
      role: 11
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          showIcon: true
        })
      }), successMessage.length != 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          showIcon: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "role",
            label: "Role",
            children: /*#__PURE__*/_jsxs(Select, {
              onChange: onRoleOptionChange,
              defaultValue: 1,
              children: [/*#__PURE__*/_jsx(Option, {
                value: 11,
                children: "Accueil"
              }), /*#__PURE__*/_jsx(Option, {
                value: 31,
                children: "Praticien"
              }), /*#__PURE__*/_jsx(Option, {
                value: 32,
                children: "Infirmier(\xE8re)"
              }), /*#__PURE__*/_jsx(Option, {
                value: 21,
                children: "Imagerie"
              }), /*#__PURE__*/_jsx(Option, {
                value: 71,
                children: "Laborantin"
              }), /*#__PURE__*/_jsx(Option, {
                value: 41,
                children: "Hospitalisation (Gestionnaire)"
              }), /*#__PURE__*/_jsx(Option, {
                value: 51,
                children: "Finance"
              }), /*#__PURE__*/_jsx(Option, {
                value: 61,
                children: "Stock & Consommables"
              }), /*#__PURE__*/_jsx(Option, {
                value: 81,
                children: "Res. Humaines"
              }), /*#__PURE__*/_jsx(Option, {
                value: 98,
                children: "Admin (Non m\xE9dical)"
              }), /*#__PURE__*/_jsx(Option, {
                value: 99,
                children: "Super Utilisateur"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "department_id",
            label: "D\xE9partment",
            children: /*#__PURE__*/_jsx(Select, {
              options: depList
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "firstname",
            label: "Pr\xE9nom",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(PersonVcardFill, {})
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "lastname",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(PersonVcardFill, {})
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "T\xE9l\xE9phone (Login)",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(TelephoneFill, {})
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "password",
            label: "Mot de passe",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input.Password, {
              prefix: /*#__PURE__*/_jsx(KeyFill, {})
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            disabled: depList.length == 0,
            loading: isFormPrecessing,
            htmlType: "submit",
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "AJOUTER"
            })
          })
        })
      })]
    })
  });
};
export default NewUserForm;